import React, { useEffect, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPOSStatus, drawPrice, istl } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Space from "../ui/Space";
import Card from "../ui/Card";
import Label from "../ui/Label";
import Divider from "../ui/Divider";

export default function OrdersList(props) {

    const {
        signal = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        route = "",
        align = "start",
        setAlign = () => { },
        view = true,
        filters = {},
        setFilters = () => { },
        row_key = "id"
    } = props;




    const buffer = 20;
    const columns = [
        { key: "cancel_date", title: <>Cancel Date</>, width: 120, align: "left"},
        { key: "clerk_code", title: <>Clerk</>, width: 80, align: "left" },
        { key: "condition_code", title: <>Cond</>, width: 60, align: "center" },
        // { key: "customer", title: <>Customer</>, width: 150, align: "left" },
        { key: "customer_po", title: <>Customer PO</>, width: 120, align: "left" },
        { key: "id", title: <>ID</>, width: 220, align: "left" },
        // { key: "invoice", title: <>Invoice</>, width: 100, align: "left" },
        // { key: "invoice_date", title: <>Invoice Date</>, width: 120, align: "left"},
        // { key: "invoice_price", title: <>Price</>, width: 90, align: "right" },
        // { key: "is_single_title_order", title: <>Single</>, width: 70, align: "center"},
        // // { key: "ms_split", title: <>Split</>, width: 90, align: "left" },
        // // { key: "note", title: <>Note</>, width: 120, align: "left"},
        // { key: "order_number", title: <>Order #</>, width: 90, align: "left" },
        // { key: "order_separator", title: <>Sep</>, width: 60, align: "center" },
        // { key: "po_number", title: <>PO #</>, width: 100, align: "left" },
        // { key: "primary_code", title: <>Primary Code</>, width: 140, align: "left" },
        // { key: "quantity", title: <>Qty</>, width: 70, align: "right" },
        // { key: "review_days", title: <>Review Days</>, width: 100, align: "right" },
        // { key: "status", title: <>Status</>, width: 90, align: "center" },
        // { key: "status_date", title: <>Status Date</>, width: 120, align: "left" },
        // { key: "supplier", title: <>Supplier</>, width: 100, align: "left" },
        // { key: "supplier_discount", title: <>Discount</>, width: 90, align: "right" },
    ];



    // {
    //     "cancel_date": 1557817200000,
    //     "clerk_code": "",
    //     "condition_code": " ",
    //     "customer": null,
    //     "customer_po": "",
    //     "id": "019a5fd0-8eb2-704b-8258-8bc7af5979bb",
    //     "invoice": "IN0040098",
    //     "invoice_date": 1551945600000,
    //     "invoice_price": 595,
    //     "is_single_title_order": false,
    //     "ms_split": [],
    //     "note": [],
    //     "order_number": "J0315",
    //     "order_separator": " ",
    //     "po_number": "IN0040098",
    //     "primary_code": "5060359301772",
    //     "quantity": 6,
    //     "review_days": 0,
    //     "status": "Rcvd",
    //     "status_date": 1552633200000,
    //     "supplier": "PAPE",
    //     "supplier_discount": 50
    // }


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;

        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("order.getNext", { ...filters, "order_id": data[data.length - 1]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("order.getPrevious", { ...filters, "order_id": data[0]?.[row_key] }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetch = () => {
        if (loading) { return }
        setLoading(true);
        pubCall("order.getInitial", { ...filters }, (_s, _r) => {
            if (_s) {

                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));

                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, []);



    return (
        <div style={{ "display": (view) ? "block" : "none", "padding": "0px 15px" }}>
            <Label style={{ "textAlign": "left" }}>&nbsp;Search Results:</Label>
            <div className="shim" />
            <Space grow size={10} style={{ "alignItems": "start" }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 600 }}>

                    <VirtualTable
                        scrollbar={true}
                        scrollindicator={true}
                        infinite={true}
                        onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                        next={next}
                        prev={prev}
                        onLoadMore={(_start, _end, _prepend) => {
                            if (_prepend) {
                                if (data?.length > 0 && data[0]?.number !== 1) {
                                    fetchPrev()
                                }
                            } else {
                                if (data?.length > 0) {
                                    fetchNext();
                                }

                            }
                        }}
                        align={align}
                        row_key={"id"}
                        current={selected}
                        data={data}
                        height={251}
                        columns={columns}
                        width={0}
                        loading={loading}
                        offset={430}
                        route={route}
                    />
                </div>

            </Space>

        </div >
    )
}